import { JSX } from "react"
import {
  Typography, TypographyProps, Stack, StackProps
} from "@mui/material";

export type ValueSpanProps = {
  pin?: JSX.Element
  text?: string | null
  body?: JSX.Element
  prefix?: string
  prefixProps?: TypographyProps
  suffix?: string
  suffixProps?: TypographyProps
  stackProps?: StackProps
  align?: 'left' | 'right'
} & TypographyProps
export const ValueSpan = ({
  pin,
  text,
  body,
  prefix,
  prefixProps,
  suffix,
  suffixProps,
  stackProps,
  align,
  ...others 
}: ValueSpanProps) => {
  if (!body && (text === null || text === undefined || text === '')) return <></>
  return (
    <Stack
      direction='row'
      spacing={0.5}
      alignItems='center'
      justifyContent={align === 'left' ? "flex-start" : "flex-end"}
      {...stackProps}
    >
      {pin}
      { prefix && <Typography variant='body2' color='text.secondary' component='div' {...prefixProps}>{prefix}</Typography> }
      {body}
      { text && <Typography variant='body2' color='text.primary' component='div' {...others}>{text}</Typography> }
      { suffix && <Typography variant='body2' color='text.secondary' component='div' {...suffixProps}>{suffix}</Typography> }
    </Stack>
  )
}
